var _rect, _rect2, _path, _circle, _path2, _path3, _circle2, _path4, _circle3, _path5, _circle4, _path6, _path7, _circle5, _path8, _circle6, _path9, _circle7, _path10, _circle8, _path11, _circle9, _path12, _circle10, _path13, _path14, _circle11, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBetViewA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 160 144",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 128,
    x: 8,
    y: 8,
    fill: "url(#______src_modules_setting_svg_IcoBetViewA_svg__a)",
    fillOpacity: 0.3,
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 126,
    x: 9,
    y: 9,
    stroke: "url(#______src_modules_setting_svg_IcoBetViewA_svg__b)",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    rx: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M16.833 16.833h18.333v18.333H16.833z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M16.833 34.833h18.333v18.333H16.833z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M16.833 52.833h18.333v18.333H16.833zm18-36h18.333v18.333H34.833z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M34.833 34.833h18.333v18.333H34.833z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.999,
    cy: 44,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M34.833 52.833h18.333v18.333H34.833zm18-36h18.333v18.333H52.833z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M52.833 34.833h18.333v18.333H52.833z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M52.833 52.833h18.333v18.333H52.833zm18-36h18.333v18.333H70.833z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M70.833 34.833h18.333v18.333H70.833z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.999,
    cy: 44,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M70.833 52.833h18.333v18.333H70.833z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.999,
    cy: 62,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M88.833 16.833h18.333v18.333H88.833z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M88.833 34.833h18.333v18.333H88.833z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.999,
    cy: 44,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M88.833 52.833h18.333v18.333H88.833zm18-36h18.333v18.333h-18.333z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M106.833 34.833h18.333v18.333h-18.333z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M106.833 52.833h18.333v18.333h-18.333zm18-36h18.333v18.333h-18.333z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.999,
    cy: 26,
    r: 5.833,
    stroke: "#494949",
    strokeWidth: 1.667
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M124.833 34.833h18.333v18.333h-18.333z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 1.667,
    d: "M124.833 52.833h18.333v18.333h-18.333z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0024FF",
    fillOpacity: 0.15,
    stroke: "#CBCBCB",
    strokeWidth: 2,
    d: "M17 73h21v23H17zm21 0h21v23H38z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BFF00",
    fillOpacity: 0.15,
    stroke: "#CBCBCB",
    strokeWidth: 2,
    d: "M59 73h42v23H59z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillOpacity: 0.15,
    stroke: "#CBCBCB",
    strokeWidth: 2,
    d: "M101 73h21v23h-21zm21 0h21v23h-21z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0024FF",
    fillOpacity: 0.15,
    stroke: "#CBCBCB",
    strokeWidth: 2,
    d: "M17 96h42v31H17z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BFF00",
    fillOpacity: 0.15,
    stroke: "#CBCBCB",
    strokeWidth: 2,
    d: "M59 96h42v31H59z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillOpacity: 0.15,
    stroke: "#CBCBCB",
    strokeWidth: 2,
    d: "M101 96h42v31h-42z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_setting_svg_IcoBetViewA_svg__a",
    x1: 80,
    x2: 80,
    y1: 8,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_setting_svg_IcoBetViewA_svg__b",
    x1: 152,
    x2: 70.621,
    y1: 141.486,
    y2: -22.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBetViewA);
export default __webpack_public_path__ + "static/media/IcoBetViewA.4d6de609b863104e698d12457f6429ee.svg";
export { ForwardRef as ReactComponent };